module.exports = __webpack_public_path__ + "img/lefticon.6c26d65a.svg";